/* VialArt / VialCase — cart guard. Two independent checkout rules:
     1. design guard  — a label line with no design attached
     2. minimum order — fewer than MOQ_LABELS labels in the whole cart
   Either one blocks checkout; see each block below.

   Original note (rule 1):
   A label line with NO design attached (missing _template/_design/_config_enc/
   _upload_id — possible via direct /cart/add.js calls or odd channel paths)
   must not reach checkout. This guard:
     - flags such lines in the cart page + cart drawer with a Remove button
     - blocks the checkout submit/click (capture phase) while any exist
     - hides accelerated checkout (Shop Pay etc.) while any exist
   Server-side safety net stays in Label Farm (no-design order flag).
   Identical file ships to BOTH themes; product IDs don't collide. */
(function () {
  var LABEL_PRODUCTS = {
    // VialArt
    10248497955092: 1, // Design Your Label (3 mL)
    10357007941908: 1, // Design Your Label - 10 mL
    10266061832468: 1, // Commercial / Branded Labels (both dies)
    // VialCase
    8311522132025: 1,  // Custom Vial Labels (holographic)
    8326237061177: 1   // Commercial / Branded Labels
  };
  var DESIGN_PROPS = ['_template', '_design', '_config_enc', '_upload_id', '_mix', '_design_id'];  /* _design_id added 2026-08-13: My Labels reorder posts the vault reference as
     _design_id and sends '_design'/'_template' as EMPTY strings when the saved
     record has no separate names -- hasDesign() rejects '' so a perfectly valid
     reorder read as 'no label design attached' and the guard hid checkout. */  /* _mix = Bulk Mix & Match line (designs live in the _mix JSON) */
  var badLines = [];   // [{key,title,variant}]
  var working = false;

  /* --- Minimum order. MOQ_LABELS is the SINGLE SOURCE OF TRUTH and is
     rewritten in place by Label Farm (Dashboard -> Minimum order), so do not
     restate the number anywhere else in this file. Owner 2026-08-14. --------
     Enforced AT CHECKOUT ONLY. A customer may hold fewer than 24 in the cart;
     they just cannot check out until they reach it.
     Counting is SKU-based and mirrors VARUSH.unitsOf() in assets/va-rush.js
     (the rush-fee ladder already counts whole-cart labels this way) -- prefer
     that function when it is loaded so the two can never drift apart. The pack
     size is CAPTURED from the SKU (LABEL-12-AUR = 12, LABEL-6-AUR-10ML = 6) so
     one cart can hold both dies; a literal 12 here counted every 10 mL line as
     zero and let a 6-label cart through the minimum.
     FAIL OPEN AT ZERO: a cart we cannot count -- add-ons only, an unrecognised
     SKU, or the VialCase theme's LABEL-VC-* lines, since this same file ships
     to both themes -- is never blocked. A wrong block costs a real order;
     a missed one costs a short print run we can still catch in Label Farm. */
  var MOQ_LABELS = 24;
  var moqUnits = 0;    // labels currently in the cart (0 = uncountable)
  var moqShort = 0;    // labels still needed; 0 = satisfied or not applicable
  /* 2026-09-30 owner: "moq is 24 labels per design, no more 12" - MOQ_LABELS now applies to EVERY label design
     line (a LABEL-* pack line = one design), not the cart total. Bulk (BULK-N) and add-ons are not per-design. */
  var moqLines = [];   // [{key, title, units, per, packs}] designs under MOQ_LABELS
  /* 2026-10-13 owner: 24-label minimum for the WHOLE cart (a design may be 12) - the per-design rule is OFF, MOQ_LABELS is the cart total. */
  var MOQ_PER_DESIGN = false;

  function unitsOf(it) {
    if (window.VARUSH && typeof window.VARUSH.unitsOf === 'function') {
      try { return window.VARUSH.unitsOf(it); } catch (e) {}
    }
    if (!it) return 0;
    var sku = String(it.sku || '').toUpperCase();
    var qty = Math.max(1, parseInt(it.quantity, 10) || 1);
    if (sku.indexOf('PRIORITY-PROD') === 0) return 0;   // rush fee
    var m = /^BULK-(\d+)/.exec(sku);
    if (m) return parseInt(m[1], 10) * qty;             // one line, N labels
    m = /^LABEL(?:-UP)?-(\d+)(?:-|$)/.exec(sku);         // qty = PACK COUNT
    if (m) return (parseInt(m[1], 10) || 0) * qty;      // N per pack, from the SKU
    return 0;                                           // applicator, AI fix, redesign, gift
  }

  function hasDesign(props) {
    if (!props) return false;
    for (var i = 0; i < DESIGN_PROPS.length; i++) {
      var v = props[DESIGN_PROPS[i]];
      if (v != null && String(v) !== '') return true;
    }
    return false;
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function ensureCss() {
    if (document.getElementById('va-cg-css')) return;
    var st = document.createElement('style');
    st.id = 'va-cg-css';
    st.textContent =
      '.va-cg{margin:0 0 14px;padding:12px 14px;border-radius:12px;background:linear-gradient(135deg,#3a1020,#4a1425);'
      + 'border:1px solid rgba(248,113,113,.55);color:#fff;font:600 13px/1.4 system-ui,-apple-system,sans-serif;}'
      + '.va-cg__h{font-weight:800;margin:0 0 6px;color:#fecaca;}'
      + '.va-cg__row{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:6px 0;}'
      + '.va-cg__btn{flex:none;background:#7f1d1d;color:#fff;border:1px solid rgba(248,113,113,.6);border-radius:8px;'
      + 'padding:6px 12px;font:700 12px/1 system-ui,-apple-system,sans-serif;cursor:pointer;}'
      + '.va-cg__btn:disabled{opacity:.5;cursor:wait;}'
      + 'body[data-va-cg-block] shopify-accelerated-checkout-cart,'
      + 'body[data-va-cg-block] shopify-accelerated-checkout,'
      + 'body[data-va-cg-block] .additional-checkout-buttons,'
      + 'body[data-va-moq-block] shopify-accelerated-checkout-cart,'
      + 'body[data-va-moq-block] shopify-accelerated-checkout,'
      + 'body[data-va-moq-block] .additional-checkout-buttons,'
      /* product page wraps express checkout in its own block -- hiding only the
         inner custom element still leaves the classic "Buy it now" clickable */
      + 'body[data-va-moq-block] .accelerated-checkout-block,'
      + 'body[data-va-moq-block] .shopify-payment-button,'
      + 'body[data-va-moq-block] more-payment-options-link,'
      + 'body[data-va-moq-block] .shopify-payment-button__more-options{display:none !important;}'
      /* amber, not red: a minimum is a threshold to cross, not an error */
      + '.va-moq{margin:0 0 14px;padding:12px 14px;border-radius:12px;'
      + 'background:linear-gradient(135deg,#2a1f06,#3d2c09);'
      + 'border:1px solid rgba(251,191,36,.5);color:#fff;'
      + 'font:600 13px/1.45 system-ui,-apple-system,sans-serif;}'
      + '.va-moq__h{font-weight:800;margin:0 0 5px;color:#fde68a;}'
      + '.va-moq__cta{display:inline-block;margin-top:8px;color:#0c0a03;background:#fbbf24;'
      + 'border-radius:8px;padding:7px 13px;font-weight:800;text-decoration:none;}'
      /* a blocked control must LOOK blocked -- a full-opacity button that eats
         the tap reads as a broken site, not as "not yet" */
      + '.va-blocked{opacity:.45 !important;cursor:not-allowed !important;'
      + 'filter:saturate(.6);}'
      /* the sticky bar is display:flex;flex-wrap:nowrap, so an injected child
         becomes a flex ITEM and steals width from the checkout link (272px ->
         95px, measured at 375px). Let the bar wrap ONLY while blocked and give
         the notice its own full-width row above the total + button. */
      + 'body[data-va-moq-block] #va-stickyco,'
      + 'body[data-va-cg-block] #va-stickyco{flex-wrap:wrap !important;}'
      /* No sticky bars. The bar was the ONLY thing making checkout reachable on
         a phone (button measured at y=3109, 3.8 screens down) and it never
         rendered at all above 760px -- iPad portrait and phone landscape landed
         on a cart with zero checkout controls on screen. Hide it, and instead
         lift the REAL summary + Checkout to the top on small screens. */
      + '#va-stickyco{display:none !important;}'
      /* THE cart blocker. .cart-page is a grid whose children default to
         min-width:auto, so one wide non-wrapping child (the volume-tier chip
         row) forced the columns to 1140px+400px inside a 770px container.
         body/html are overflow-x:clip, so the summary column -- and the
         Checkout button in it -- was pushed to x=1229 and CLIPPED AWAY:
         unreachable, not merely off-screen. Measured at 820px (iPad portrait,
         phone landscape), where the sticky bar also never rendered. */
      + '.cart-page>*{min-width:0 !important;}'
      + '.cart-page__summary,.cart-summary,.cart-summary__inner{min-width:0 !important;max-width:100% !important;}'
      + '@media (max-width:1024px){'
      +   '.cart-page__summary{order:-1;}'
      +   '.cart-summary__inner .cart__ctas{order:-1;margin-bottom:14px;}'
      + '}'
      + '#va-blockwhy{display:block;width:100%;box-sizing:border-box;text-align:center;'
      + 'border-radius:9px;margin:0 0 10px;'
      + 'font:700 12px/1.35 system-ui,-apple-system,sans-serif;color:#0c0a03;'
      + 'background:#fbbf24;padding:7px 10px;}';
    document.head.appendChild(st);
  }

  function boxHTML() {
    var h = '<div class="va-cg__h">&#9888;&#65039; This item has no label design attached</div>';
    for (var i = 0; i < badLines.length; i++) {
      var b = badLines[i];
      h += '<div class="va-cg__row"><span>' + b.title + '</span>'
        + '<button type="button" class="va-cg__btn" data-va-cg-remove="' + b.key + '">Remove</button></div>';
    }
    h += '<div style="font-weight:500;color:#fca5a5;margin-top:6px;">Remove it (or design it in the builder) to continue to checkout.</div>';
    return h;
  }
  /* --- Product-page express checkout -------------------------------------
     "Buy it now" / Shop Pay on a product page ADDS AND CHECKS OUT in one step;
     the cart is never rendered, so the cart-based rule above never runs. We
     cannot intercept those buttons (Shopify shadow DOM), so we hide them while
     the PROSPECTIVE purchase would land under the minimum, and explain why.
     Add-to-cart is deliberately left working -- the customer can still build up
     to the minimum in the cart. Non-label products yield 0 and are untouched. */
  function pdpVariant() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var p = meta && meta.product;
      if (!p || !p.variants || !p.variants.length) return null;
      var want = null;
      var m = /[?&]variant=(\d+)/.exec(location.search);
      if (m) want = m[1];
      if (!want) {
        var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (inp && inp.value) want = String(inp.value);
      }
      for (var i = 0; i < p.variants.length; i++) {
        if (want && String(p.variants[i].id) === String(want)) return p.variants[i];
      }
      return p.variants[0];
    } catch (e) { return null; }
  }
  function pdpQty() {
    var q = document.querySelector('form[action*="/cart/add"] [name="quantity"]')
         || document.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return Math.max(1, isNaN(n) ? 1 : n);
  }
  function pdpShortfall() {
    if (location.pathname.indexOf('/products/') !== 0) return 0;
    var v = pdpVariant();
    if (!v) return 0;
    var per = unitsOf({ sku: v.sku, quantity: 1 });
    if (!per) return 0;                       /* not a label product */
    var prospective = moqUnits + per * pdpQty();   /* whole cart + this add (2026-10-13 owner: 24-label minimum for the WHOLE cart (a design may be 12)) */
    return prospective < MOQ_LABELS ? (MOQ_LABELS - prospective) : 0;
  }
  function pdpHTML(short) {
    return '<div class="va-moq__h">' + moqTitle() + '</div>'
      + '<div>Express checkout needs at least ' + MOQ_LABELS + ' labels in your order. Add ' + short
      + ' more label' + (short === 1 ? '' : 's') + ' to your cart to use it &mdash; '
      + 'or add this to your cart and keep going.</div>';
  }

  /* The minimum is counted in LABELS, and only in labels. It used to be quoted
     as "N sheets" too, derived from a fixed 12-a-pack -- but a cart can now hold
     two strip lengths at once (3 mL packs of 12, 10 mL packs of 6), so a sheet
     count is either wrong or unanswerable. Owner 2026-09-02: drop it.
     MOQ_LABELS itself stays operator-settable from the Label Farm dashboard
     (core/moq.py rewrites the declaration above), so never restate the number. */
  function moqTitle() {
    return 'Minimum order ' + MOQ_LABELS + ' labels';
  }
  function moqEsc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function moqHTML() {
    if (moqLines.length) {
      return '<div class="va-moq__h">' + moqTitle() + '</div>'
        + '<div>Each design needs at least ' + MOQ_LABELS + ' labels (' + Math.ceil(MOQ_LABELS / (moqLines[0].per || 12)) + ' packs).</div>'
        + moqLines.map(function (l) {
            return '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:8px">'
              + '<span><b>' + moqEsc(l.title) + '</b> &middot; ' + l.units + ' labels</span>'
              + '<button type="button" class="va-moq__cta" data-va-moq-fix="' + moqEsc(l.key) + '" data-q="' + l.packs + '">Make it ' + (l.packs * l.per) + '</button></div>';
          }).join('');
    }
    return '<div class="va-moq__h">' + moqTitle() + '</div>'
      + '<div>Your cart has ' + moqUnits + ' label' + (moqUnits === 1 ? '' : 's') + '. '
      + 'Add ' + moqShort + ' more label' + (moqShort === 1 ? '' : 's')
      + ' to check out.</div>'
      + '<a class="va-moq__cta" href="/">Add more labels &rarr;</a>';
  }
  /* one tap: bump that design line to the minimum, then reload so the cart re-renders with the new price */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-va-moq-fix]'); if (!b) return;
    e.preventDefault(); b.disabled = true; b.textContent = 'Updating\u2026';
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-va-moq-fix'), quantity: parseInt(b.getAttribute('data-q'), 10) || 2 }) })
      .then(function () { location.reload(); }).catch(function () { location.reload(); });
  });
  function placeBox(container, id, cls, html) {
    if (!container) return;
    var el = document.getElementById(id);
    if (!html) { if (el) el.remove(); return; }
    if (!el || !container.contains(el)) {
      if (el) el.remove();
      el = document.createElement('div');
      el.id = id;
      el.className = cls;
      el.setAttribute('role', 'alert');
      container.insertBefore(el, container.firstChild);
    }
    if (el.getAttribute('data-sig') !== html) { el.setAttribute('data-sig', html); el.innerHTML = html; }
  }
  function render() {
    ensureCss();
    /* two independent rules, two independent attributes -- neither clobbers
       the other, and checkout is blocked while EITHER is set */
    if (badLines.length) document.body.setAttribute('data-va-cg-block', '1');
    else document.body.removeAttribute('data-va-cg-block');
    var pdpShort = pdpShortfall();
    /* the attribute's only job is hiding accelerated/express checkout, so the
       product page sets it too -- click/submit blocking stays cart-driven */
    if (moqShort || pdpShort) document.body.setAttribute('data-va-moq-block', '1');
    else document.body.removeAttribute('data-va-moq-block');
    if (pdpShort) {
      var acc = document.querySelector('.accelerated-checkout-block')
        || document.querySelector('shopify-accelerated-checkout')
        || document.querySelector('.additional-checkout-buttons');
      if (acc && acc.parentElement) {
        placeBox(acc.parentElement, 'va-moq-pdp', 'va-moq', pdpHTML(pdpShort));
      }
    } else {
      var old = document.getElementById('va-moq-pdp');
      if (old) old.remove();
    }
    var cg = badLines.length ? boxHTML() : '';
    var mq = moqShort ? moqHTML() : '';
    /* Publish the numbers so the cart's volume strip can carry this message
       itself instead of us stacking a second amber card under it (owner
       2026-08-19: "very messy hard to understand and spammy looking").
       Dispatched BEFORE placeBox so a listener can claim it in the same tick.
       The checkout BLOCK above is untouched - this is presentation only. */
    window.VA_MOQ = { min: MOQ_LABELS, units: moqUnits, short: moqShort };
    try { document.dispatchEvent(new CustomEvent('va:moq', { detail: window.VA_MOQ })); } catch (e) {}
    var drawer = document.querySelector('.cart-drawer__content');
    markControls();
    placeBox(drawer, 'va-cg-drawer', 'va-cg', cg);
    placeBox(drawer, 'va-moq-drawer', 'va-moq', mq);
    if (location.pathname.indexOf('/cart') === 0) {
      var page = document.querySelector('.cart-page') || document.getElementById('MainContent');
      placeBox(page, 'va-cg-page', 'va-cg', cg);
      /* stand down ONLY if the volume strip actually shows the message - if it
         is absent (VialCase theme, render failure) the card still renders, so a
         blocked customer is never left without a reason */
      var claimed = !!document.querySelector('.va-ladder[data-va-moq]');
      placeBox(page, 'va-moq-page', 'va-moq', claimed ? '' : mq);
    }
  }

  function sync() {
    return getCart().then(function (cart) {
      var bad = [];
      (cart.items || []).forEach(function (it) {
        if (LABEL_PRODUCTS[it.product_id] && !hasDesign(it.properties)) {
          var t = it.product_title || 'Label';
          if (it.variant_title) t += ' — ' + it.variant_title;
          bad.push({ key: it.key, title: t });
        }
      });
      badLines = bad;
      var units = 0;
      (cart.items || []).forEach(function (it) { units += unitsOf(it); });
      moqUnits = units;
      var lines = [];
      (cart.items || []).forEach(function (it) {
        var sku = String(it.sku || '').toUpperCase(), m = /^LABEL(?:-UP)?-(\d+)(?:-|$)/.exec(sku);
        if (!m) return;                                    /* only design packs count per design */
        var u = unitsOf(it), per = parseInt(m[1], 10) || 0;
        if (MOQ_PER_DESIGN && u > 0 && per > 0 && u < MOQ_LABELS) {
          var pr = it.properties || {};
          var t = pr._design || pr.Design || pr['Custom Text'] || it.product_title || 'Label';
          lines.push({ key: it.key, title: String(t), units: u, per: per, packs: Math.ceil(MOQ_LABELS / per) });
        }
      });
      moqLines = lines;
      /* units === 0 -> nothing countable in the cart -> do not block */
      var perDesign = 0; lines.forEach(function (l) { perDesign += MOQ_LABELS - l.units; });
      var total = (units > 0 && units < MOQ_LABELS) ? (MOQ_LABELS - units) : 0;
      moqShort = Math.max(perDesign, total);
      render();
    }).catch(function () {});
  }

  // Remove buttons
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-va-cg-remove]');
    if (!btn || working) return;
    working = true; btn.disabled = true;
    removeLine(btn.getAttribute('data-va-cg-remove')).then(function () {
      working = false;
      if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
      sync();
    }).catch(function () { working = false; btn.disabled = false; });
  }, true);

  function isCheckoutControl(el) {
    if (!el || !el.closest) return false;
    /* #vas-pay-here = AI Studio "Didn't open? Check out in this tab" fallback,
       which does location.href='/checkout' (sections/va-ai-studio.liquid). */
    return !!el.closest('#checkout,[name="checkout"],a[href^="/checkout"],'
      + '.cart__checkout-button,#vas-pay-here');
  }
  function blocked() { return badLines.length > 0 || moqShort > 0; }
  function blockWhy() {
    if (badLines.length) return 'Remove the item with no design to check out';
    if (moqLines.length) return 'Each design needs ' + MOQ_LABELS + '+ labels';
    if (moqShort) return 'Minimum ' + MOQ_LABELS + ' labels \u2014 add ' + moqShort + ' more';
    return '';
  }
  var CHECKOUT_SEL = '#checkout,[name="checkout"],a[href^="/checkout"],'
    + '.cart__checkout-button,#vas-pay-here';
  /* Dim + label every checkout control, and put the reason INSIDE the sticky
     mobile bar, which is the only thing on screen when a phone user taps. */
  function markControls() {
    var on = blocked(), why = blockWhy();
    var els = document.querySelectorAll(CHECKOUT_SEL);
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (on) {
        e.classList.add('va-blocked');
        e.setAttribute('aria-disabled', 'true');
        if (why) e.setAttribute('title', why);
      } else {
        e.classList.remove('va-blocked');
        e.removeAttribute('aria-disabled');
        e.removeAttribute('title');
      }
    }
    /* sits directly above the real Checkout button, which is now the first
       thing in the summary on small screens */
    var ctas = document.querySelector('.cart__ctas');
    var note = document.getElementById('va-blockwhy');
    if (on && ctas && ctas.parentNode) {
      if (!note) {
        note = document.createElement('div');
        note.id = 'va-blockwhy';
      }
      if (note.nextSibling !== ctas) ctas.parentNode.insertBefore(note, ctas);
      if (note.textContent !== why) note.textContent = why;
    } else if (note) { note.remove(); }
  }
  function block(e) {
    e.preventDefault();
    e.stopPropagation();
    var box = document.getElementById('va-cg-page') || document.getElementById('va-moq-page')
      || document.getElementById('va-cg-drawer') || document.getElementById('va-moq-drawer');
    if (box && box.scrollIntoView) box.hasAttribute("data-noscroll");
  }
  // Capture-phase: block checkout clicks + form submits while bad lines exist
  document.addEventListener('click', function (e) {
    if (blocked() && isCheckoutControl(e.target)) block(e);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!blocked()) return;
    var f = e.target;
    var sub = e.submitter;
    var isCheckout = (sub && sub.name === 'checkout') || (f && f.querySelector && f.querySelector('[name="checkout"]') && String(f.action || '').indexOf('/cart') !== -1);
    if (isCheckout) block(e);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  /* the sticky mobile bar is injected by the cart script AFTER we render, and
     Horizon re-renders sections on its own, so re-apply on a light interval */
  setInterval(markControls, 900);

  /* a product page's quantity/variant changes the prospective total */
  if (location.pathname.indexOf('/products/') === 0) {
    var pdpT;
    var repaint = function () { clearTimeout(pdpT); pdpT = setTimeout(render, 120); };
    document.addEventListener('change', repaint, true);
    document.addEventListener('input', repaint, true);
    document.addEventListener('click', repaint, true);   /* +/- steppers */
  }

  // Re-check after any cart mutation (chained fetch patch, same as va-freegift).
  var deb;
  function schedule() { clearTimeout(deb); deb = setTimeout(sync, 350); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : String((input && (input.url || input.href)) || ''); } catch (e) {}
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) { p.then(schedule, function () {}); }
      return p;
    };
  }
  // Survive Horizon section morphing (re-inject the box)
  try {
    var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(render, 150); });
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
    if (location.pathname.indexOf('/cart') === 0) {
      var main = document.getElementById('MainContent');
      if (main) mo.observe(main, { childList: true, subtree: true });
    }
  } catch (e) {}
})();

/* va-checkout-sweep (owner 2026-08-18): the LAST gate before payment. Every
   checkout attempt re-screens the whole cart's custom text through the shared
   server list, and a session that had an artwork denial can't check out custom
   uploads without review. Fail OPEN on network problems. */
(function () {
  var BUSY = false;
  function fp() { try { return localStorage.getItem('va_fp') || ''; } catch (e) { return ''; } }
  function sweep(cb) {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var texts = [], hasUpload = false;
      (cart.items || []).forEach(function (it) {
        var pr = it.properties || {};
        for (var k in pr) {
          var v = pr[k];
          if (typeof v === 'string' && v && v.length < 200 && k.charAt(0) !== '_'
              && !/^https?:|^data:/.test(v)) texts.push(v);
          if (/upload/i.test(k) || (typeof v === 'string' && /custom_upload/.test(v))) hasUpload = true;
        }
        if (/upload/i.test(it.product_title || '') || /upload/i.test(String(it.handle || ''))) hasUpload = true;
      });
      if (!texts.length && !hasUpload) { cb(null); return; }
      fetch('https://vialart-scan.vialart.workers.dev/text-scan', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ texts: texts, fp: fp() })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (!j) { cb(null); return; }
        if (j.flags && j.flags.length) { cb({ kind: 'flag', note: j.flags[0].note, term: j.flags[0].term }); return; }
        if (j.strike && hasUpload) {
          cb({ kind: 'strike', note: 'Some artwork from this session needs a manual review before we can '
            + 'accept the order. Please contact us at vialart.com/pages/contact and we\u2019ll take a look \u2014 '
            + 'usually within 24 business hours.' });
          return;
        }
        cb(null);
      }).catch(function () { cb(null); });
    }).catch(function () { cb(null); });
  }
  function refuse(res) {
    try {
      if (window.VA_REFUSAL && res.kind === 'flag') {
        VA_REFUSAL.show({ term: res.term || 'blocked content' }, { field: 'Cart', surface: 'checkout' });
        return;
      }
    } catch (e) {}
    alert(res.note);
  }
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest
      ? e.target.closest('button[name="checkout"],a[href*="/checkout"],#checkout,[data-checkout],.cart__checkout-button')
      : null;
    if (!el || BUSY) return;
    if (el.dataset.vaSwept === '1') { el.dataset.vaSwept = ''; return; }   /* re-entry after clean sweep */
    e.preventDefault(); e.stopPropagation();
    BUSY = true;
    var t0 = el.textContent;
    try { el.textContent = 'Checking\u2026'; } catch (er) {}
    sweep(function (res) {
      BUSY = false;
      try { el.textContent = t0; } catch (er) {}
      if (res) { refuse(res); return; }
      el.dataset.vaSwept = '1';
      el.click();
    });
  }, true);
})();


/* 2026-09-30 owner: "try to cart the minimum and then turn it down to 12 - it shouldn't be able to".
   In the cart (page + drawer) a label DESIGN line (SKU LABEL-<per>-*) can't go below ceil(MIN / per) packs:
   the minus button disables at the floor and a typed quantity under it snaps back. Remove still works (0 is allowed).
   MIN comes from the guard above (window.VA_MOQ.min = MOQ_LABELS), so the dashboard setting stays the one source. */
(function () {
  function minLabels() { return (window.VA_MOQ && +window.VA_MOQ.min) || 24; }
  var cart = null, busy = 0, timer = 0;
  function perOf(it) {
    var m = /^LABEL(?:-UP)?-(\d+)(?:-|$)/.exec(String((it && it.sku) || '').toUpperCase());
    return m ? (parseInt(m[1], 10) || 0) : 0;
  }
  /* 2026-10-13 owner: 24-label minimum for the WHOLE cart (a design may be 12): no per-design floor.
     2026-11-03 owner: "label design $20 a label. Minimum required labels is going to be 10" - the Label Redesign
     Service line (REDESIGN-1, qty = label designs) floors at 10; a line added below it (product page) is raised once. */
  var RDS_MIN = 10, bumped = {};
  function isRds(it) { return String((it && it.sku) || '').toUpperCase() === 'REDESIGN-1'; }
  function floorOf(it) { return isRds(it) ? RDS_MIN : 0; }
  function minMsg(it) { return isRds(it) ? 'Minimum ' + RDS_MIN + ' labels for the design service' : 'Minimum ' + minLabels() + ' labels per design'; }
  function bump(it, fl) {
    if (!it || bumped[it.key]) return; bumped[it.key] = 1;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: it.key, quantity: fl }) }).then(function (r) { if (r.ok) location.reload(); }).catch(function () {});
  }
  function itemFor(inp) {
    var n = parseInt(inp.getAttribute('data-cart-line'), 10);
    return (cart && n > 0) ? cart.items[n - 1] : null;
  }
  function selectorOf(el) { return el.closest('cart-quantity-selector-component,.quantity-selector,quantity-selector-component'); }
  function note(qs, on, msg) {
    if (!qs) return;
    var n = qs.parentNode && qs.parentNode.querySelector(':scope > .va-qmin');
    if (on && !n) {
      n = document.createElement('div'); n.className = 'va-qmin';
      n.style.cssText = 'font-size:11.5px;font-weight:700;opacity:.75;margin-top:4px;';
      n.textContent = msg || ('Min ' + minLabels() + ' labels per design');
      qs.parentNode.insertBefore(n, qs.nextSibling);
    } else if (!on && n) { n.remove(); }
  }
  function apply() {
    var inputs = document.querySelectorAll('input[name="updates[]"][data-cart-line]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i], it = itemFor(inp), fl = floorOf(it);
      if (!fl) continue;
      var q0 = parseInt(inp.value, 10) || 0;
      if (q0 > 0 && q0 < fl) bump(it, fl);
      inp.min = String(fl); inp.setAttribute('data-min', String(fl));
      var qs = selectorOf(inp), minus = qs && qs.querySelector('button[name="minus"]');
      var at = (parseInt(inp.value, 10) || 0) <= fl;
      if (minus) { minus.disabled = at; minus.setAttribute('aria-disabled', at ? 'true' : 'false'); minus.title = at ? minMsg(it) : ''; }
      note(qs, at, minMsg(it));
    }
  }
  function load() {
    if (busy) return; busy = 1;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; busy = 0; apply(); }).catch(function () { busy = 0; });
  }
  function soon() { clearTimeout(timer); timer = setTimeout(load, 250); }

  // minus at the floor: swallow it before the cart component sees it
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="minus"]'); if (!b) return;
    var qs = selectorOf(b), inp = qs && qs.querySelector('input[name="updates[]"][data-cart-line]'); if (!inp) return;
    var fl = floorOf(itemFor(inp));
    if (fl && (parseInt(inp.value, 10) || 0) <= fl) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      b.disabled = true; note(qs, true, minMsg(itemFor(inp)));
      if (typeof window.toast === 'function') window.toast(minMsg(itemFor(inp)) + ' - use Remove to delete it');
    }
  }, true);
  // typed quantity under the floor (but not 0 = remove): snap back BEFORE the component reads it
  function fixTyped(e) {
    var inp = e.target; if (!inp || inp.name !== 'updates[]' || !inp.hasAttribute('data-cart-line')) return;
    var fl = floorOf(itemFor(inp)), v = parseInt(inp.value, 10);
    if (fl && v > 0 && v < fl) {
      inp.value = String(fl);
      if (typeof window.toast === 'function') window.toast(minMsg(itemFor(inp)));
    }
  }
  document.addEventListener('blur', fixTyped, true);
  document.addEventListener('change', fixTyped, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') fixTyped(e); }, true);

  // the cart re-renders after every change: re-read it and re-apply
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('cart-items-component,.cart-items,.cart-drawer,cart-drawer-component,form[action="/cart"]')) { soon(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('cart:update', soon);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
